// src/components/About.js
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import EmailApi from '../../components/common/index'; // Adjust path if needed
import './About.css';
import client1 from '../../assets/images/client23.webp'
import client2 from '../../assets/images/client22.webp'
import client3 from '../../assets/images/client20.webp'
import client4 from '../../assets/images/client21.webp'
import client5 from '../../assets/images/client3.webp'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import ceo from '../../assets/images/BharadwajMM3.png'
import itmanager from '../../assets/images/SureshITM2.png'
import md from '../../assets/images/MD SIRR.png'
import com from '../../assets/images/RushyaSir.png'
import dmm from '../../assets/images/AshokDmm.png'
import ITmd from '../../assets/images/Hrithiksir2.png'
import {
  FaReact,
  FaNodeJs,
  FaPython,
  FaAws,
  FaAngular,
  FaDocker,
  FaVuejs,
  FaJava,
  FaAndroid,
  FaApple,
  FaPhp,
  FaLaravel,
} from "react-icons/fa";
import {
  SiTensorflow,
  SiKubernetes,
  SiGooglecloud,
} from "react-icons/si";

const About = () => {
  const location = useLocation();
  const [formStatus, setFormStatus] = useState('');
  const [isMobile, setIsMobile] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormStatus('Sending...');

    // Basic client-side validation
    const formData = new FormData(e.target);
    const name = formData.get('name');
    const email = formData.get('email');
    const subject = formData.get('subject');
    const message = formData.get('message');

    if (!name || !email || !subject || !message) {
      setFormStatus('Please fill all fields.');
      setTimeout(() => setFormStatus(''), 3000);
      return;
    }

    // Prepare data as URL-encoded (better for PHP forms)
    const params = new URLSearchParams();
    params.append('full_name', name);
    params.append('email', email);
    params.append('subject', subject);
    params.append('message', message);

    try {
      const { url, method } = EmailApi.SendMail;
      const response = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: params,
      });

      if (response.ok) {
        setFormStatus('Message sent successfully 🚀');
        e.target.reset();
        setTimeout(() => setFormStatus(''), 4000);
      } else {
        throw new Error(`Server error: ${response.status}`);
      }
    } catch (error) {
      console.error('API Error:', error);
      setFormStatus('Failed to send message. Please try again.');
      setTimeout(() => setFormStatus(''), 4000);
    }
  };

  // Intersection Observer for team cards
  useEffect(() => {
    console.log('Setting up Intersection Observer for team cards...');
   
    const observer = new IntersectionObserver(
      (entries) => {
        console.log('Intersection entries found:', entries.length);
        entries.forEach((entry) => {
          console.log('Card intersection:', entry.isIntersecting, entry.target);
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            console.log('✅ Added visible class to card');
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      }
    );
    const teamCards = document.querySelectorAll('.team-card');
    console.log('🎯 Found team cards:', teamCards.length);
   
    teamCards.forEach((card, index) => {
      console.log(`Observing card ${index + 1}`);
      observer.observe(card);
    });
    return () => {
      teamCards.forEach((card) => {
        observer.unobserve(card);
      });
    };
  }, []);

  // Card toggle functionality
  useEffect(() => {
    const handleCardClick = (event) => {
      const button = event.target.closest('.mc-btn-action');
      if (!button) return;
      const card = button.closest('.material-card');
      const icon = button.querySelector('i');
      // Add spin animation
      icon.classList.add('fa-spin-fast');
      // Close all other open cards before toggling the clicked one
      const allCards = document.querySelectorAll('.material-card.mc-active');
      allCards.forEach((c) => {
        if (c !== card) {
          c.classList.remove('mc-active');
          const otherIcon = c.querySelector('.mc-btn-action i');
          if (otherIcon) {
            otherIcon.classList.remove('fa-arrow-left');
            otherIcon.classList.add('fa-bars');
          }
        }
      });
      // Now toggle the clicked card
      if (card.classList.contains('mc-active')) {
        card.classList.remove('mc-active');
        setTimeout(() => {
          icon.classList.remove('fa-arrow-left', 'fa-spin-fast');
          icon.classList.add('fa-bars');
        }, 800);
      } else {
        card.classList.add('mc-active');
        setTimeout(() => {
          icon.classList.remove('fa-bars', 'fa-spin-fast');
          icon.classList.add('fa-arrow-left');
        }, 800);
      }
    };
    document.addEventListener('click', handleCardClick);
    return () => {
      document.removeEventListener('click', handleCardClick);
    };
  }, []);

  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const element = document.querySelector(location.hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 500);
    }
  }, [location]);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
   
    checkMobile();
    window.addEventListener('resize', checkMobile);
   
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <div>
      {/* Hero Section */}
      <section id="home" className="about-hero about-fade-in">
        <div className="about-logo-container">
          {/* <img src="/images/Oakya It services .webp" alt="Oakya IT Logo" className="about-rotating-logo" /> */}
        </div>
        <h1>Transforming Businesses Through <span>Innovative IT Solutions</span></h1>
        <p>We provide cutting-edge technology services to help your business thrive in the digital age</p>
      </section>
     
      {/* Who We Are */}
      <section id="about" className="about-who-we-are about-fade-in">
        <h2>Who We Are</h2>
        <p>Oakya IT Services is a forward-thinking technology partner dedicated to empowering businesses with innovative digital solutions. With years of industry experience, our team of experts delivers exceptional service tailored to your unique needs.</p>
        <p>We combine technical expertise with business acumen to create solutions that drive growth, efficiency, and competitive advantage in today's rapidly evolving digital landscape.</p>
      </section>
     
      <section className="about-mission-vision">
        <div className="mission-vision-container">
          {/* Mission Card */}
          <div className="mission-card mission-vision-card animate pop">
            <div className="card-overlay">
              <div className="overlay-content animate slide-left delay-2">
                <h2 className="animate slide-left pop delay-4">
                  <i className="fas fa-bullseye"></i> Our Mission
                </h2>
                <p className="animate slide-left pop delay-5" style={{ color: 'white', marginBottom: '2.5rem' }}>
                  Purpose: <em>Empower & Transform</em>
                </p>
              </div>
              <div className="image-content mission-image animate slide delay-5"></div>
              <div className="dots animate">
                <div className="dot animate slide-up delay-6"></div>
                <div className="dot animate slide-up delay-7"></div>
                <div className="dot animate slide-up delay-8"></div>
              </div>
            </div>
            <div className="card-text">
              <p>
                To empower businesses with transformative technology solutions that drive growth, innovation, and sustainable success in the digital era. We believe in creating meaningful impact through cutting-edge solutions.
              </p>
              <p>
                Our mission extends beyond just delivering projects - we aim to build lasting partnerships that foster innovation and drive tangible business results for our clients worldwide.
              </p>
              <p>
                Through continuous learning and adaptation, we stay at the forefront of technological advancements to provide the most effective solutions.
              </p>
            </div>
          </div>
          {/* Vision Card */}
          <div className="vision-card mission-vision-card animate pop">
            <div className="card-overlay">
              <div className="overlay-content animate slide-left delay-2">
                <h2 className="animate slide-left pop delay-4">
                  <i className="fas fa-eye"></i> Our Vision
                </h2>
                <p className="animate slide-left pop delay-5" style={{ color: 'white', marginBottom: '2.5rem' }}>
                  Future: <em>Innovate & Lead</em>
                </p>
              </div>
              <div className="image-content vision-image animate slide delay-5"></div>
              <div className="dots animate">
                <div className="dot animate slide-up delay-6"></div>
                <div className="dot animate slide-up delay-7"></div>
                <div className="dot animate slide-up delay-8"></div>
              </div>
            </div>
            <div className="card-text">
              <p>
                To be the leading catalyst for digital transformation, helping businesses worldwide unlock their full potential through cutting-edge technology and innovative thinking.
              </p>
              <p>
                We envision a future where technology seamlessly enhances human potential and creates unprecedented opportunities for growth and development across all industries.
              </p>
              <p>
                Our vision drives us to push boundaries, challenge conventions, and create solutions that not only meet today's needs but also anticipate tomorrow's challenges.
              </p>
            </div>
          </div>
        </div>
      </section>
     

           {/* Animated Astronaut Hero Section */}
      {/* <section className="astronaut-hero-section">
        <div className="astronaut-container">
          <object
            type="image/svg+xml"
            data="https://cdn.svgator.com/assets/main-page/fold1/astronaut-hero.svg"
            aria-label="Animated astronaut floating in space"
          >
            Your browser does not support SVG
          </object>
        </div>
      </section> */}
      {/* Why Choose Us */}
      <section className="about-why-choose">
        <h2>Why Choose Us</h2>
        <div className="about-why-cards">
          <div className="about-why-card about-fade-in">
            <i className="fas fa-lightbulb"></i>
            <h3>Innovative Solutions</h3>
            <p>We stay ahead of technology trends to deliver forward-thinking solutions.</p>
          </div>
          <div className="about-why-card about-fade-in">
            <i className="fas fa-users"></i>
            <h3>Expert Team</h3>
            <p>Our skilled professionals bring years of industry experience to your project.</p>
          </div>
          <div className="about-why-card about-fade-in">
            <i className="fas fa-rocket"></i>
            <h3>Fast Delivery</h3>
            <p>We prioritize efficiency without compromising on quality.</p>
          </div>
          <div className="about-why-card about-fade-in">
            <i className="fas fa-shield-alt"></i>
            <h3>Secure & Reliable</h3>
            <p>Your data and systems are protected with enterprise-grade security.</p>
          </div>
        </div>
      </section>
     
      {/* Our Team Section - UPDATED WITH MATERIAL CARDS */}
      {/* <section id="team" className="about-our-team">
        <h2>Our Team</h2>
        <div className="team-cards-container">
          <article className="material-card team-card Cyan">
            <h2>
              <span>K. Hema Ram Reddy</span>
              <strong>
                <i className="fa fa-fw fa-star"></i>
                Managing Director
              </strong>
            </h2>
            <div className="mc-content">
              <div className="img-container">
                <img src={md} alt="K. Hema Ram Reddy" />
              </div>
              <div className="mc-description">
                <ul className="team-bulletpoints">
                  <li>Leading with vision, inspiring with action.</li>
                  <li>Turning vision into value, every step forward.</li>
                  <li>Guiding growth through purpose and leadership.</li>
                </ul>
              </div>
            </div>
            <a className="mc-btn-action">
              <i className="fa fa-bars"></i>
            </a>
            <div className="mc-footer">
              <h4>Connect</h4>
              <a className="fa fa-fw fa-envelope"></a>
              <a className="fa fa-fw fa-globe"></a>
            </div>
          </article>
          <article className="material-card team-card Cyan">
            <h2>
              <span>Sai hrithik Peddi</span>
              <strong>
                <i className="fa fa-fw fa-star"></i>
                IT Director
              </strong>
            </h2>
            <div className="mc-content">
              <div className="img-container">
                <img src={ITmd} alt="Sai hrithik Peddi" />
              </div>
              <div className="mc-description">
                <ul className="team-bulletpoints">
                  <li>Leading IT with clear vision.</li>
                  <li>Turning technology into business value.</li>
                  <li>Driving growth through smart IT leadership.</li>
                </ul>
              </div>
            </div>
            <a className="mc-btn-action">
              <i className="fa fa-bars"></i>
            </a>
            <div className="mc-footer">
              <h4>Connect</h4>
              <a className="fa fa-fw fa-envelope"></a>
              <a className="fa fa-fw fa-globe"></a>
            </div>
          </article>
          <article className="material-card team-card Cyan">
            <h2>
              <span>K. Rushya Rao</span>
              <strong>
                <i className="fa fa-fw fa-star"></i>
                Chief Operations Manager
              </strong>
            </h2>
            <div className="mc-content">
              <div className="img-container">
                <img src={com} alt="K. Rushya Rao" />
              </div>
              <div className="mc-description">
                <ul className="team-bulletpoints">
                  <li>Precision in every process, excellence in every outcome.</li>
                  <li>Transforming operations into opportunities.</li>
                  <li>Streamlining success with strategy and efficiency.</li>
                </ul>
              </div>
            </div>
            <a className="mc-btn-action">
              <i className="fa fa-bars"></i>
            </a>
            <div className="mc-footer">
              <h4>Connect</h4>
              <a className="fa fa-fw fa-envelope"></a>
              <a className="fa fa-fw fa-globe"></a>
            </div>
          </article>
          <article className="material-card team-card Cyan">
            <h2>
              <span>K. Suresh</span>
              <strong>
                <i className="fa fa-fw fa-star"></i>
                IT Manager
              </strong>
            </h2>
            <div className="mc-content">
              <div className="img-container">
                <img src={itmanager} alt="K. Suresh" />
              </div>
              <div className="mc-description">
                <ul className="team-bulletpoints">
                  <li>Powering progress through technology.</li>
                  <li>Turning code into capability, and systems into solutions.</li>
                  <li>Building smarter networks for a smarter future.</li>
                </ul>
              </div>
            </div>
            <a className="mc-btn-action">
              <i className="fa fa-bars"></i>
            </a>
            <div className="mc-footer">
              <h4>Connect</h4>
              <a className="fa fa-fw fa-envelope"></a>
              <a className="fa fa-fw fa-globe"></a>
            </div>
          </article>
          <article className="material-card team-card Cyan">
            <h2>
              <span>C. Bharadwaj</span>
              <strong>
                <i className="fa fa-fw fa-star"></i>
                Marketing Manager
              </strong>
            </h2>
            <div className="mc-content">
              <div className="img-container">
                <img src={ceo} alt="C. Bharadwaj" />
              </div>
              <div className="mc-description">
                <ul className="team-bulletpoints">
                  <li>Driving innovation, delivering excellence.</li>
                  <li>Where strategy meets success.</li>
                  <li>Empowering ideas to shape the future.</li>
                </ul>
              </div>
            </div>
            <a className="mc-btn-action">
              <i className="fa fa-bars"></i>
            </a>
            <div className="mc-footer">
              <h4>Connect</h4>
              <a className="fa fa-fw fa-envelope"></a>
              <a className="fa fa-fw fa-globe"></a>
            </div>
          </article>
          <article className="material-card team-card Cyan">
            <h2>
              <span>N. Ashok</span>
              <strong>
                <i className="fa fa-fw fa-star"></i>
                Digital Marketing Manager
              </strong>
            </h2>
            <div className="mc-content">
              <div className="img-container">
                <img src={dmm} alt="N. Ashok" />
              </div>
              <div className="mc-description">
                <ul className="team-bulletpoints">
                  <li>Connecting brands to hearts, not just screens.</li>
                  <li>Turning clicks into connections, and data into growth.</li>
                  <li>Crafting digital stories that inspire action.</li>
                </ul>
              </div>
            </div>
            <a className="mc-btn-action">
              <i className="fa fa-bars"></i>
            </a>
            <div className="mc-footer">
              <h4>Connect</h4>
              <a className="fa fa-fw fa-envelope"></a>
              <a className="fa fa-fw fa-globe"></a>
            </div>
          </article>
          
        </div>
      </section> */}

      <section id="team" className="leadership-section">
  <div className="container">
    <div className="leader-layout">
      {/* Left: Prominent portrait with layered background */}
      <div className="leader-portrait">
        <div className="portrait-frame">
          {/* Replaced <img> with <div> for background layering */}
          <div 
            className="leader-image"
            role="img"
            aria-label="K. Hema Ram Reddy - Managing Director"
          />
          <div className="accent-line"></div>
        </div>
      </div>

      {/* Right: Content block */}
      <div className="leader-content">
        <div className="title-block">
          <h2>K. Hema Ram Reddy</h2>
          <p className="position">Managing Director</p>
        </div>

        <div className="mission-statement">
          <p className="intro">
            A visionary leader committed to driving innovation, sustainable growth, and lasting value.
          </p>
        </div>

        <ul className="core-principles">
          <li>Leading with vision, inspiring with action.</li>
          <li>Turning vision into value, every step forward.</li>
          <li>Guiding growth through purpose and leadership.</li>
        </ul>

        <div className="connect-area">
          <h4>Connect with Leadership</h4>
          <div className="icons-row">
            <a href="mailto:info@oakyaitservices.com" className="connect-link" aria-label="Email">
              <i className="fa fa-envelope"></i>
            </a>
            <a href="https://www.linkedin.com/company/oakya-it-services/" className="connect-link" aria-label="Website">
              <i className="fa fa-globe"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


      {/* Technologies Section */}
      <section id="technologies" className="about-tech-section">
        <h2>Technologies We Use</h2>
        <div className="about-tech-logos">
          <div className="about-tech-item about-fade-in">
            <div className="about-tech-icon-wrapper">
              <FaReact size={40} color="#00d8ff" />
            </div>
            <p>React</p>
          </div>
          <div className="about-tech-item about-fade-in">
            <div className="about-tech-icon-wrapper">
              <FaNodeJs size={40} color="#68a063" />
            </div>
            <p>Node.js</p>
          </div>
          <div className="about-tech-item about-fade-in">
            <div className="about-tech-icon-wrapper">
              <FaPython size={40} color="#3776ab" />
            </div>
            <p>Python</p>
          </div>
          <div className="about-tech-item about-fade-in">
            <div className="about-tech-icon-wrapper">
              <FaAws size={40} color="#ff9900" />
            </div>
            <p>AWS</p>
          </div>
          <div className="about-tech-item about-fade-in">
            <div className="about-tech-icon-wrapper">
              <FaAngular size={40} color="#dd0031" />
            </div>
            <p>Angular</p>
          </div>
          <div className="about-tech-item about-fade-in">
            <div className="about-tech-icon-wrapper">
              <FaDocker size={40} color="#0db7ed" />
            </div>
            <p>Docker</p>
          </div>
          <div className="about-tech-item about-fade-in">
            <div className="about-tech-icon-wrapper">
              <FaVuejs size={40} color="#42b883" />
            </div>
            <p>Vue.js</p>
          </div>
          <div className="about-tech-item about-fade-in">
            <div className="about-tech-icon-wrapper">
              <FaJava size={40} color="#007396" />
            </div>
            <p>Java</p>
          </div>
          <div className="about-tech-item about-fade-in">
            <div className="about-tech-icon-wrapper">
              <FaAndroid size={40} color="#3ddc84" />
            </div>
            <p>Android</p>
          </div>
          <div className="about-tech-item about-fade-in">
            <div className="about-tech-icon-wrapper">
              <FaApple size={40} color="#999999" />
            </div>
            <p>Swift</p>
          </div>
          <div className="about-tech-item about-fade-in">
            <div className="about-tech-icon-wrapper">
              <FaPhp size={40} color="#8892be" />
            </div>
            <p>PHP</p>
          </div>
          <div className="about-tech-item about-fade-in">
            <div className="about-tech-icon-wrapper">
              <FaLaravel size={40} color="#ff2d20" />
            </div>
            <p>Laravel</p>
          </div>
          <div className="about-tech-item about-fade-in">
            <div className="about-tech-icon-wrapper">
              <SiGooglecloud size={40} color="#4285f4" />
            </div>
            <p>Google Cloud</p>
          </div>
          <div className="about-tech-item about-fade-in">
            <div className="about-tech-icon-wrapper">
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24">
                <path fill="#0078D4" d="M12.001 0L2.344 20.486l5.343 3.087L12.001 12l4.313 11.573l5.342-3.087z"/>
              </svg>
            </div>
            <p>Azure</p>
          </div>
          <div className="about-tech-item about-fade-in">
            <div className="about-tech-icon-wrapper">
              <SiTensorflow size={40} color="#ff6f00" />
            </div>
            <p>TensorFlow</p>
          </div>
          <div className="about-tech-item about-fade-in">
            <div className="about-tech-icon-wrapper">
              <SiKubernetes size={40} color="#326ce5" />
            </div>
            <p>Kubernetes</p>
          </div>
        </div>
      </section>

      {/* Timeline (Process) - New Vertical Representation */}
      <section className="about-timeline">
        <h2>Our Work Process</h2>
        <div className="about-timeline-container">
          <div className="about-timeline-step about-fade-in">
            <div className="about-timeline-icon">
              <i className="fas fa-handshake"></i>
            </div>
            <h3>Discovery & Consultation</h3>
            <p>We begin by understanding your business goals through detailed consultations, identifying challenges, and defining a tailored strategy.</p>
            <a href="#">Learn More +</a>
          </div>
          <div className="about-timeline-step about-fade-in">
            <div className="about-timeline-icon">
              <i className="fas fa-drafting-compass"></i>
            </div>
            <h3>Planning & Design</h3>
            <p>Our team creates a comprehensive roadmap and designs innovative solutions, ensuring alignment with your vision and technical requirements.</p>
            <a href="#">View Designs +</a>
          </div>
          <div className="about-timeline-step about-fade-in">
            <div className="about-timeline-icon">
              <i className="fas fa-code"></i>
            </div>
            <h3>Development & Testing</h3>
            <p>We build robust solutions using agile methodologies, with continuous testing to ensure high quality and performance standards.</p>
            <a href="#">See Progress +</a>
          </div>
          <div className="about-timeline-step about-fade-in">
            <div className="about-timeline-icon">
              <i className="fas fa-sync-alt"></i>
            </div>
            <h3>Review & Iteration</h3>
            <p>Your feedback shapes our iterative process, allowing us to refine and optimize the solution to meet your exact needs.</p>
            <a href="#">Provide Feedback +</a>
          </div>
          <div className="about-timeline-step about-fade-in">
            <div className="about-timeline-icon">
              <i className="fas fa-rocket"></i>
            </div>
            <h3>Launch & Support</h3>
            <p>We deploy the solution seamlessly and provide ongoing support to ensure long-term success and scalability.</p>
            <a href="#">Get Started +</a>
          </div>
        </div>
      </section>
     
      {/* Testimonials Section */}
      <section className="testimonials-wrapper">
  <div className="c-container">
    <div className="section-title">
      <h2>What Clients Say</h2>
      <div className="separator"></div>
    </div>
    <Slider
      dots={true}
      infinite={true}
      speed={500}
      slidesToShow={isMobile ? 1 : 2}
      slidesToScroll={1}
      arrows={false}
      autoplay={true}
      autoplaySpeed={3000}
      responsive={[
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 0,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]}
    >
      {/* Testimonial 1 */}
      <div className="testimonial-block">
        <div className="inner-box">
          <div className="image">
            <img src={client1} alt="Dr. Nagendra Babu" />
          </div>
          <div className="content">
            <i className="fas fa-quote-right"></i>
            <div className="text">
              Oakya IT Services significantly improved our hospital’s digital identity with a strategy that truly reflects our holistic philosophy. Their expertise enhanced our online reach and helped us engage a younger audience interested in natural healthcare solutions.
            </div>
            <div className="author-info">
              Dr. Nagendra Babu <span>/ Chief Physician</span>
            </div>
          </div>
        </div>
      </div>

      {/* Testimonial 2 */}
      <div className="testimonial-block">
        <div className="inner-box">
          <div className="image">
            <img src={client2} alt="Ravi Shankar" />
          </div>
          <div className="content">
            <i className="fas fa-quote-right"></i>
            <div className="text">
              Oakya IT Services understands our goals and works as a dependable strategic partner. Their customized content and lead generation efforts improved our brand visibility and consistently attracted quality clients aligned with our business objectives. Highly Recommeded! .
            </div>
            <div className="author-info">
              BCT <span>/ Team BCT</span>
            </div>
          </div>
        </div>
      </div>

      {/* Testimonial 3 */}
      <div className="testimonial-block">
        <div className="inner-box">
          <div className="image">
            <img src={client3} alt="Anita Kumar" />
          </div>
          <div className="content">
            <i className="fas fa-quote-right"></i>
            <div className="text">
              Partnering with Oakya IT Services was a turning point for our restaurant. They delivered a complete digital solution that preserved our brand heritage while strengthening our online presence and attracting new customers effectively.
            </div>
            <div className="author-info">
              M. Venkata Chowdary <span>/ Restaurant Founder</span>
            </div>
          </div>
        </div>
      </div>

      {/* Testimonial 4 */}
      <div className="testimonial-block">
        <div className="inner-box">
          <div className="image">
            <img src={client4} alt="John Doe" />
          </div>
          <div className="content">
            <i className="fas fa-quote-right"></i>
            <div className="text">
              Oakya IT Services contributed greatly to Asian Crop Care’s growth by strengthening our digital presence. Their expertise in web design and marketing helped us connect more effectively with farmers and distribution partners.
            </div>
            <div className="author-info">
              Jagadeesh Garlapati <span>/ Business Owner</span>
            </div>
          </div>
        </div>
      </div>

      {/* Testimonial 5 */}
      <div className="testimonial-block">
        <div className="inner-box">
          <div className="image">
            <img src={client5} alt="John Doe" />
          </div>
          <div className="content">
            <i className="fas fa-quote-right"></i>
            <div className="text">
              Oakya IT Services developed a modern and responsive website for Sri Jyothi Polytechnic College. Their professional approach and timely delivery greatly improved our online presence and overall digital engagement.
            </div>
            <div className="author-info">
              Sri Jyothi Polytechnic College <span>/ College</span>
            </div>
          </div>
        </div>
      </div>
    </Slider>
  </div>
</section>


      {/* Contact Section */}
      <section id="contact" className="about-contact about-fade-in">
        <h2>Get In Touch</h2>
        <div className="about-contact-container">
          <div className="about-contact-info">
            <h3>Contact Information</h3>
            <div className="about-contact-details">
              <p><i className="fas fa-map-marker-alt"></i> <a href="https://www.google.com/maps?q=4th+Floor,+MKR+Enclave,+kamayyathopu,+Pantakaluva+Road,+NTR+Marg,+Kanuru,+Vijayawada,+Andhra+Pradesh"
                target="_blank" rel="noopener noreferrer"> 4th Floor, MKR Enclave, kamayyathopu,
                Pantakaluva Road, NTR Marg, Kanuru,
                Vijayawada, Andhra Pradesh, 520007.</a></p>
              <div className='about-mobile-num'><i className="fas fa-phone"></i>
              <div><a href="tel:+919134747474">+91 9134747474</a>
                {/* <a href="tel:+919912566969">+91 9912566969</a> */}
                </div></div>
              <p><i className="fas fa-envelope"></i><a href="mailto:info@oakyaitservices.com"> info@oakyaitservices.com</a></p>
              <p><i className="fas fa-clock"></i> Mon-Fri: 9AM - 5PM</p>
            </div>
            <div className="about-social-links">
              <a href="https://www.facebook.com/oakyaitservices"><i className="fab fa-facebook-f"></i></a>
              <a href="https://x.com/oakyaitservices?s=21"><i className="fab fa-twitter"></i></a>
              <a href="https://www.linkedin.com/company/oakya-it-services/"><i className="fab fa-linkedin-in"></i></a>
              <a href="https://www.instagram.com/oakya_itservices/"><i className="fab fa-instagram"></i></a>
            </div>
          </div>
          <div className="about-contact-form">
            <form onSubmit={handleSubmit}>
              <div className="about-form-group">
                <label htmlFor="name">Your Name</label>
                <input type="text" id="name" name="name" required />
              </div>
              <div className="about-form-group">
                <label htmlFor="email">Your Email</label>
                <input type="email" id="email" name="email" required />
              </div>
              <div className="about-form-group">
                <label htmlFor="subject">Subject</label>
                <input type="text" id="subject" name="subject" required />
              </div>
              <div className="about-form-group">
                <label htmlFor="message">Your Message</label>
                <textarea id="message" name="message" required></textarea>
              </div>
              <button type="submit" className="about-submit-btn">Send Message</button>
              <p className="about-form-status">{formStatus}</p>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;